// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2QYE6","name":"ConsentHeader_name__3ddRJ","birthday":"ConsentHeader_birthday__152NC","skeleton":"ConsentHeader_skeleton__10-Gk"};